import React, {useEffect, useState} from "react";
import { Card, CardBody, Row, Col, Input, Button } from 'reactstrap';
import Select from 'react-select';
import {formatModifyDate} from "../../../components/Common/CommonLogic";

const SearchDetails = ({showHistory, searchData, trackingEvents}) => {
    const [recentEvent, setRecentEvent] = useState({});
    useEffect(() => {
        setRecentEvent(trackingEvents.filter(e => e.event_recent === true));
    }, [trackingEvents]);

    return (
        <>
            <Card className="shadow rounded-4 p-3 mb-4">
                <CardBody>
                    <Row>
                        <Col md="3">
                            <h6 className="text-muted mb-1">Container:</h6>
                            <h5 className="fw-bold">{searchData?.container?.number}</h5>
                            <small>Container type: {searchData?.container?.type}</small>
                        </Col>
                        <Col md="3">
                            <h6 className="text-muted mb-1">From:</h6>
                            <div className="fw-bold">{searchData?.pol?.port} {searchData?.pol?.country}</div>
                            <small>{formatModifyDate(searchData?.pol?.etd_date)}</small>
                        </Col>
                        <Col md="3">
                            <h6 className="text-muted mb-1">To:</h6>
                            <div className="fw-bold">{searchData?.pod?.port} {searchData?.pod?.country}</div>
                            <small>{formatModifyDate(searchData?.pod?.eta_date)}</small>
                        </Col>
                        <Col md="3">
                            <h6 className="text-muted mb-1">Last status:</h6>
                            {(recentEvent?.[0]?.location?.port !== '' && recentEvent?.[0]?.location?.country !== '') && (
                                <div className="fw-bold">{recentEvent?.[0]?.location?.port}, {recentEvent?.[0]?.location?.country}</div>
                            )}
                            <small>{recentEvent?.[0]?.location?.terminal}</small>
                            <br/>
                            <small>{recentEvent?.[0]?.action?.action_name} {recentEvent?.[0]?.mode?.transport_mode}<br />{recentEvent?.[0]?.event_date && formatModifyDate(recentEvent?.[0].event_date)}</small>
                        </Col>
                    </Row>

                    <hr className="my-3" />

                    <Row className="justify-content-center">
                        <Col md="auto">
                            <Button color="primary" className="w-100" onClick={showHistory}>More details</Button>
                        </Col>
                    </Row>
                </CardBody>
            </Card>
        </>
    );
}

export default SearchDetails;
